var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
        'media-counter': true
    }, _obj[("media-counter--" + _vm.size)] = _vm.size, _obj["media-counter--disabled"] = _vm.disabled, _obj['media-counter--clickable'] =  _vm.clickable, _obj ),on:{"click":_vm.onClick}},[_c('div',{staticClass:"media-counter__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }